import { Tooltip } from '@chakra-ui/react';
import { EMPTY_STATE_IMAGES } from '@shared/constants';
import { InfoIcon, LeftArrowIcon, RightArrowIcon } from '@sketchnote/icons';
import React, { useState } from 'react';
import { EmptyStateDashboard } from 'src/features/dashboard/components/EmptyState';

const DEFAULT_EMPTY_CONTENT = [
  'No data to show',
  'Start activity in the file for data charts to appear',
];

export const ChartBase = ({
  title = '',
  data,
  noData = false,
  emptyStateTextArray = DEFAULT_EMPTY_CONTENT,
  datepicker,
  infoLabel = null,
}: {
  title: string;
  data: {
    type: string;
    chart: JSX.Element;
  }[];
  noData?: boolean;
  emptyStateTextArray?: string[];
  datepicker?: React.ReactElement;
  infoLabel?: React.ReactNode;
}) => {
  const chartTypes = data.map((i) => i.type);
  const [chartTypeIndex, setChartTypeIndex] = useState(0);

  const onChangeType = (dir: 'prev' | 'next') => {
    if (dir === 'next') {
      setChartTypeIndex((type) => {
        if (type === chartTypes.length - 1) return 0;
        else return type + 1;
      });
    } else if (dir === 'prev') {
      setChartTypeIndex((type) => {
        if (type === 0) return chartTypes.length - 1;
        else return type - 1;
      });
    }
  };

  const renderChart = () => {
    switch (chartTypes[chartTypeIndex]) {
      case 'donut':
        return data.find((i) => i.type === 'donut')?.chart;
      case 'bar':
        return data.find((i) => i.type === 'bar')?.chart;
      case 'line':
        return data.find((i) => i.type === 'line')?.chart;
    }
  };

  return (
    <div className="bg-white rounded-sm shadow-sm p-16 mr-32">
      <div className="flex items-center justify-between relative">
        <div className="text-gray-500 font-medium">{title}</div>
        {infoLabel && (
          <Tooltip label={infoLabel} fontSize="lg" bg="gray.600">
            <span>
              <InfoIcon size={14} className="text-gray-400 cursor-pointer" />
            </span>
          </Tooltip>
        )}
      </div>
      <div className="h-330 m-auto">
        {noData ? (
          <EmptyStateDashboard
            contents={emptyStateTextArray}
            src={EMPTY_STATE_IMAGES.analytics}
            wrapperClass="h-full items-center"
            className="bg-gray-200"
          />
        ) : (
          renderChart()
        )}
      </div>
      {chartTypes.length > 1 && !noData && (
        <div className="flex items-center">
          <button className="flex mr-16" onClick={() => onChangeType('prev')}>
            <LeftArrowIcon wrapperClass="p-12 bg-primary-100 rounded-lg" fill="#254DDA" />
          </button>
          <button className="flex mr-16" onClick={() => onChangeType('next')}>
            <RightArrowIcon wrapperClass="p-12 bg-primary-100 rounded-lg" fill="#254DDA" />
          </button>
          <div className=" text-xs text-gray-500 capitalize">
            {chartTypeIndex + 1} / {chartTypes.length} {chartTypes[chartTypeIndex]}
          </div>
        </div>
      )}
      <div className="flex justify-end">{datepicker}</div>
    </div>
  );
};
